export default __webpack_public_path__ + "static/einhornalone_mail-bc177b70bc3048394baa337fc844ba73.svg";